import { SparkleOutline } from '@lyearn/icons';
import { cn, css } from '@lyearn/style';
import { EditorOptionType } from '@/components/Editor/PlainEditor/types';

import { TOOLBAR_ADD_AI_CONTENT } from '../../consts';
import AddAIContent from '../AIBaseEditor/components/Toolbar/AddAIContent';

// styles corresponding to the icon size "small"
// we need to use css because we cannot control
// the size prop via EditorOptionType interface
const smallIconSize = css`
  width: 2.4rem;
  height: 2.4rem;
  padding: 0.4rem;
`;

export const AI_MESSAGE_INPUT_EDITOR_OPTIONS = [TOOLBAR_ADD_AI_CONTENT];

export const AI_MESSAGE_INPUT_EDITOR_OPTION_MAP = new Map<string, EditorOptionType>([
  [
    TOOLBAR_ADD_AI_CONTENT,
    {
      Component: AddAIContent,
      key: TOOLBAR_ADD_AI_CONTENT,
      className: cn('absolute top-12 end-12', smallIconSize),
      classes: {
        popoverContent: '!-ms-[0.7rem] !mt-[0.7rem]',
      },
      Icon: SparkleOutline,
      blockName: '',
      tooltipKey: 'AI:AskLyearnAI',
    },
  ],
]);
